import { DocumentNode } from 'graphql';
import React, { useEffect, useState } from 'react';
import { LookupModel } from 'types/graphql';
import useApolloClient from 'useApolloClient';

interface ILookupWrapperProps<TQuery, TQueryVariables> {
  queryDocument: DocumentNode;
  queryVariables: TQueryVariables;
  selectedValues?: number[];
  extractLookups: (query: TQuery) => LookupModel[];
  children: (params: {
    lookups: LookupModel[];
    selectedLookups: LookupModel[];
    someSelectedValuesNoLongerAvailable: boolean;
  }) => JSX.Element;
}

export const LookupWrapper = <TQuery, TQueryVariables>(
  props: ILookupWrapperProps<TQuery, TQueryVariables>,
): JSX.Element => {
  const { client } = useApolloClient();
  const [lookups, setLookups] = useState<LookupModel[]>([]);

  const fetchLookups = () => {
    client
      .query<TQuery, TQueryVariables>({
        query: props.queryDocument,
        variables: props.queryVariables,
        fetchPolicy: 'no-cache',
      })
      .then((value) => {
        setLookups(props.extractLookups(value.data));
      });
  };

  useEffect(fetchLookups, [props.queryVariables]);

  const validSelectedValues = props.selectedValues?.filter((selectedValue) =>
    lookups.find((lookup) => lookup.id === selectedValue),
  );

  const selectedLookups = lookups.filter((option) => {
    return (
      validSelectedValues?.length &&
      validSelectedValues?.indexOf(option.id) !== -1
    );
  });

  const someSelectedValuesNoLongerAvailable =
    validSelectedValues?.length !== props.selectedValues?.length;

  return (
    <>
      {props.children({
        lookups,
        selectedLookups,
        someSelectedValuesNoLongerAvailable,
      })}
    </>
  );
};
